// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div v-if="$store.state.showViewSettingsDialog" class="vs-container" @click.stop="() => $store.commit('setShowViewSettingsDialog', false)">
    <div class="vs-body" @click.stop="() => {}">
      <div class="vs-row">
        <div class="vs-title">{{$t('View Settings')}}</div>
        <v-icon class="vs-icon"  @click="() => $store.commit('setShowViewSettingsDialog', false)">mdi-close</v-icon>
      </div>
      <v-card-text class="vs-font-size" style="padding-top: 0; margin-top: 0;">
        <v-checkbox style="margin-top: 0;" hide-details :label="$t('Milky Way')" v-model="milkyWayOn"></v-checkbox>
        <v-checkbox hide-details :label="$t('DSS')" v-model="dssOn"></v-checkbox>
        <v-checkbox hide-details :label="$t('Meridian Line')" v-model="meridianOn"></v-checkbox>
        <v-checkbox hide-details :label="$t('Ecliptic Line')" v-model="eclipticOn"></v-checkbox>
      </v-card-text>
    </div>
  </div>
</template>

<script>

  export default {
    data: function () {
      return {}
    },
    computed: {
      dssOn: {
        get: function () {
          return this.$store.state.stel.dss.visible
        },
        set: function (newValue) {
          this.$stel.core.dss.visible = newValue
        }
      },
      milkyWayOn: {
        get: function () {
          return this.$store.state.stel.milkyway.visible
        },
        set: function (newValue) {
          this.$stel.core.milkyway.visible = newValue
        }
      },
      meridianOn: {
        get: function () {
          return this.$store.state.stel.lines.meridian.visible
        },
        set: function (newValue) {
          this.$stel.core.lines.meridian.visible = newValue
        }
      },
      eclipticOn: {
        get: function () {
          return this.$store.state.stel.lines.ecliptic.visible
        },
        set: function (newValue) {
          this.$stel.core.lines.ecliptic.visible = newValue
        }
      }
    }
  }
</script>

<style>
  .vs-container {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: auto;
    z-index: 1;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .vs-body {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 400px;
    background: #323256;
    border-radius: 8px;
    padding: 0 20px;
    color: rgba(255, 255, 255, 0.8);
  }

  .vs-row {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .vs-icon {
    color: rgba(255, 255, 255, 0.8) !important;
    font-size: 25px !important;
    padding: 15px;
  }

  .vs-icon:active {
    opacity: 0.5;
  }

  .mdi-checkbox-marked, .mdi-checkbox-blank-outline {
    transform: scale(0.9);
  }

  .vs-title {
    display: flex;
    margin-left: 12px;
    font-size: 16px;

  }

  .v-label {
    font-size: 15px !important;
  }

  @media screen and (max-width: 500px) {
    .vs-body {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 80%;
      background: #323256;
      border-radius: 5px;
      padding: 0 15px;
      color: rgba(255, 255, 255, 0.8);
    }


    .vs-icon {
      color: rgba(255, 255, 255, 0.8) !important;
      font-size: 22px !important;
      padding: 15px;
    }

    .vs-icon:active {
      opacity: 0.5;
    }

    .mdi-checkbox-marked, .mdi-checkbox-blank-outline {
      transform: scale(0.8);
    }

    .vs-title {
      display: flex;
      margin-left: 12px;
      font-size: 15px;

    }

    .v-label {
      font-size: 14px !important;
    }

  }
</style>
